import styled from 'styled-components';
import type { ReactNode } from 'react';

import { Notification } from 'components/Toolkit/Notification/Notification';

export interface ToastProps {
  type: 'INFO' | 'SUCCESS' | 'ERROR';
  text: string | ReactNode;
  hideIcon?: boolean;
  largeIconOnDesktop?: boolean;
  closeOnClick?: boolean;
  customId?: number;
  autoClose?: number;
}

const SNotification = styled(Notification)`
  // Included to account for absolute positioned close button
  padding-right: ${({ theme }) => theme.spacing.L40};
`;

export const fireToast = async ({
  type = 'SUCCESS',
  text,
  hideIcon = false,
  largeIconOnDesktop = true,
  closeOnClick = true,
  customId,
  autoClose = 5000,
}: ToastProps) => {
  import(/* webpackChunkName: "fireToast" */ 'react-toastify').then(
    ({ toast }) => {
      return toast(
        <SNotification
          type={type}
          variant={'TOAST'}
          hideIcon={hideIcon}
          text={text}
          largeIconOnDesktop={largeIconOnDesktop}
        />,
        { closeOnClick, toastId: customId, autoClose },
      );
    },
  );
};
